<template>
  <div class="message-all noselect">
    <m-header title="Notifications">
      <span
        class="top-right"
        slot="right"
        @click="clearMsg"
        >Empty</span
      >
    </m-header>
    <div class="message-main m-scroll">
      <div class="msg-tools">
        <div class="tools-main">
          <div
            class="tool-item"
            @click="$router.push({ path: '/en/logistics' })"
          >
            <img src="@/assets/message/icon_jiaoyi@2x.png" alt="" />
            <span>Order Tracking</span>
            <van-tag
              type="danger"
              v-if="readCode.logistics_message"
              class="tools-dot"
              round
              v-finger:press-move="pressMove"
              v-finger:multipoint-end="endMove"
              >{{ readCode.logistics_message }}</van-tag
            >
            <img src="@/assets/message/icon-fanhui@2x.png" alt="" />
          </div>
          <div
            class="tool-item"
            @click="$router.push({ path: '/en/activity' })"
          >
            <img src="@/assets/message/icon_huodong@2x.png" alt="" />
            <span>Mail</span>
            <van-tag
              type="danger"
              v-if="readCode.site_message"
              class="tools-dot"
              round
              v-finger:press-move="pressMove"
              v-finger:multipoint-end="endMove"
              >{{ readCode.site_message }}</van-tag
            >
            <img src="@/assets/message/icon-fanhui@2x.png" alt="" />
          </div>
        </div>
      </div>
      <div class="msg-list">
        <van-swipe-cell>
          <div class="msg-item van-hairline--bottom m-padding">
            <img
              src="@/assets/leftbar/moobyyoho.png"
              alt=""
              @click="
                $router.push({ path: '/en/customer', query: { id: item } })
              "
            />
            <div class="msg-info">
              <p class="msg-store">
                <span
                  @click="
                    $router.push({ path: '/en/customer', query: { id: item } })
                  "
                  >Customer of Mooby</span
                >
              </p>
              <p
                class="msg-content"
                @click="
                  $router.push({ path: '/en/customer', query: { id: item } })
                "
              >
                Click to view customer contact information~
              </p>
            </div>
          </div>
        </van-swipe-cell>
        <van-swipe-cell v-for="(item, index) in msgList" :key="index">
          <div class="msg-item van-hairline--bottom m-padding">
            <img
              src="@/assets/message/icon_jiaoyi@2x.png"
              alt=""
              @click="$router.push({ path: '/en/chat', query: { id: item } })"
            />
            <van-tag
              type="danger"
              class="msg-dot"
              round
              v-finger:press-move="pressMove"
              v-finger:multipoint-end="endMove"
              >1</van-tag
            >
            <div class="msg-info">
              <p class="msg-store">
                <span
                  @click="
                    $router.push({ path: '/en/chat', query: { id: item } })
                  "
                  >Mooby nini</span
                >
                <span>2020.6.30</span>
              </p>
              <p
                class="msg-content"
                @click="$router.push({ path: '/en/chat', query: { id: item } })"
              >
                Click me if you have any questions~
              </p>
            </div>
          </div>

          <template #right>
            <van-button
              square
              text="delete"
              type="danger"
              class="delete-button"
            />
          </template>
        </van-swipe-cell>
      </div>
    </div>
  </div>
</template>

<script>
import MHeader from "@/components/en/tab-header.vue";
import { news_total, news_all_red } from "@/api/zh/message.js";
export default {
  components: { MHeader },
  data() {
    return {
      movePos: [0, 0],
      msgList: [],
      readCode: {},
    };
  },
  methods: {
    getData() {
      news_total().then((res) => {
        if (res) {
          this.readCode = res;
        }
      });
    },
    clearMsg() {
      // 清除消息
      if (this.readCode.logistics_message || this.readCode.site_message) {
        this.$dialog
          .confirm({
            title: "Remind",
            message: "Are you sure to clear the message log?",
          })
          .then(() => {
            news_all_red().then((res) => {
              if (res) {
                this.$notify({ type: "success", message: res.msg });
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$notify({ type: "warning", message: "No unread messages" });
      }
    },
    pressMove(e) {
      e.preventDefault();
      e.stopPropagation();
      this.movePos = [this.movePos[0] + e.deltaX, this.movePos[1] + e.deltaY];
      e.target.style.transform = `translate(${this.movePos[0]}px, ${this.movePos[1]}px)`;
      e.target.style.opacity =
        (20 -
          Math.sqrt(
            this.movePos[0] * this.movePos[0] +
              this.movePos[1] * this.movePos[1]
          )) /
        20;
    },
    endMove(e) {
      e.preventDefault();
      e.stopPropagation();
      if (Math.abs(this.movePos[0]) > 20 || Math.abs(this.movePos[1]) > 20) {
        e.target.style.display = "none";
      } else {
        e.target.style.transform = "translate(0px, 0px)";
      }

      this.movePos = [0, 0];
      e.target.style.opacity = 1;
    },
  },
  created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
@import "./index.less";
</style>
<style lang="less">
.msg-list {
  .van-button {
    height: 100% !important;
  }
}
.top-right{font-size: 12px; font-weight: 600; color: #2a65ba !important;}
</style>